module.exports = __webpack_public_path__ + "static/img/17.d995d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/17.png
// module id = gCzp
// module chunks = 1